/* ABE home: marquee pause, countdown digits, woes ticker.
   Fixture name and date are server-rendered. This file only fills the digits
   and moves the visible fixture when the cached HTML is behind the clock.
   No poll and no newsletter handler: the list is a Shopify customer form. */
(function () {
  if (window.__abeHome) return;
  window.__abeHome = true;

  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (/[?&]shot=1/.test(location.search)) document.documentElement.classList.add("shot");

  document.querySelectorAll("[data-abe-band]").forEach(function (band) {
    var lists = band.querySelectorAll(".band__list");
    if (lists[1] && !lists[1].children.length && lists[0]) {
      lists[1].innerHTML = lists[0].innerHTML;
    }
    var toggle = band.querySelector(".band__toggle");
    if (!toggle) return;
    toggle.addEventListener("click", function () {
      var paused = band.classList.toggle("is-paused");
      toggle.setAttribute("aria-pressed", paused ? "true" : "false");
      toggle.setAttribute("aria-label", paused ? "Play the banter band" : "Pause the banter band");
      var icon = toggle.querySelector("[data-icon]");
      if (icon) icon.textContent = paused ? "\u25B6" : "\u275A\u275A";
    });
  });

  document.querySelectorAll("[data-countdown]").forEach(function (root) {
    var blocks = [].slice.call(root.querySelectorAll("[data-kickoff]"));
    var windowMs = (parseInt(root.getAttribute("data-window"), 10) || 10800) * 1000;
    var liveText = root.getAttribute("data-live") || "";
    var suffixText = root.getAttribute("data-suffix") || "";
    var clock = root.querySelector(".count__clock");
    var suffix = root.querySelector("[data-suffix]");
    var pad = function (n) { return String(n).padStart(2, "0"); };

    var tick = function () {
      var now = Date.now();
      var active = null;
      for (var i = 0; i < blocks.length; i++) {
        var ko = Date.parse(blocks[i].getAttribute("data-kickoff"));
        if (!ko) continue;
        if (now < ko + windowMs) {
          active = { el: blocks[i], ko: ko };
          break;
        }
      }
      if (!active) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      blocks.forEach(function (block) {
        block.hidden = block !== active.el;
      });
      var ms = active.ko - now;
      if (ms <= 0) {
        if (clock) clock.hidden = true;
        if (suffix) suffix.textContent = liveText;
        return;
      }
      if (clock) clock.hidden = false;
      if (suffix) suffix.textContent = suffixText;
      var secs = Math.floor(ms / 1000);
      var days = clock && clock.querySelector("[data-d]");
      var hours = clock && clock.querySelector("[data-h]");
      var mins = clock && clock.querySelector("[data-m]");
      var seconds = clock && clock.querySelector("[data-s]");
      if (days) days.textContent = String(Math.floor(secs / 86400));
      if (hours) hours.textContent = pad(Math.floor((secs % 86400) / 3600));
      if (mins) mins.textContent = pad(Math.floor((secs % 3600) / 60));
      if (seconds) seconds.textContent = pad(secs % 60);
    };

    tick();
    setInterval(tick, 1000);
  });

  document.querySelectorAll("[data-woes]").forEach(function (root) {
    var list = root.querySelector("[data-woes-list]");
    var board = root.querySelector("[data-woes-board]");
    if (!list || !board) return;
    var rows = [].slice.call(list.children);
    if (!rows.length) return;
    var index = 0;
    var timer = null;
    var paused = reduce;

    var show = function (n) {
      index = (n + rows.length) % rows.length;
      rows.forEach(function (row, i) {
        row.classList.toggle("is-on", i === index);
      });
      var no = board.querySelector("[data-board-no]");
      var of = board.querySelector("[data-board-of]");
      var year = board.querySelector("[data-board-year]");
      var fact = board.querySelector("[data-board-fact]");
      var bar = board.querySelector("[data-board-bar]");
      if (no) no.textContent = String(index + 1).padStart(2, "0");
      if (of) of.textContent = "/ " + rows.length;
      var yearEl = rows[index].querySelector("b");
      var factEl = rows[index].querySelector("span");
      if (year && yearEl) year.textContent = yearEl.textContent;
      if (fact && factEl) fact.textContent = factEl.textContent;
      if (bar) bar.style.width = ((index + 1) / rows.length * 100) + "%";
      board.classList.remove("is-flip");
      void board.offsetWidth;
      if (!reduce) board.classList.add("is-flip");
    };

    var play = function () {
      clearInterval(timer);
      if (!paused) timer = setInterval(function () { show(index + 1); }, 5000);
    };

    var pauseButton = root.querySelector("[data-woes-pause]");
    var setPause = function (next) {
      paused = next;
      if (pauseButton) {
        pauseButton.setAttribute("aria-pressed", paused ? "true" : "false");
        pauseButton.setAttribute("aria-label", paused ? "Play the woes ticker" : "Pause the woes ticker");
        var icon = pauseButton.querySelector("[data-icon]");
        if (icon) icon.textContent = paused ? "\u25B6" : "\u275A\u275A";
      }
      play();
    };

    var prev = root.querySelector("[data-woes-prev]");
    var next = root.querySelector("[data-woes-next]");
    if (prev) prev.addEventListener("click", function () { show(index - 1); setPause(true); });
    if (next) next.addEventListener("click", function () { show(index + 1); setPause(true); });
    if (pauseButton) pauseButton.addEventListener("click", function () { setPause(!paused); });

    var start = /[?&]woe=(\d+)/.exec(location.search);
    show(start ? (+start[1] - 1) : 0);
    setPause(paused);
  });
})();
